"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _spinner = _interopRequireDefault(require("./spinner.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Spinner = function Spinner() {
  return /*#__PURE__*/_react["default"].createElement("img", {
    src: _spinner["default"],
    alt: "NIC-place Spinner"
  });
};

var _default = Spinner;
exports["default"] = _default;